import {
  getGetUserExitTicketGeneratorsQueryKey,
  getGetTopExitTicketGeneratorsQueryKey,
  likeExitTicketGenerator,
  unlikeExitTicketGenerator,
  useDeleteExitTicketGenerator,
  useGetUserExitTicketGenerators,
  useGetTopExitTicketGenerators,
} from "@packages/api/madlenAPI";
import {
  ExitTicket,
  ExitTicketCard,
} from "../../components/exit_tickets/ExitTicketCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { BaseTeacherToolResponseDtoStatus } from "@packages/api/madlenAPI.schemas";
import i18n from "@packages/i18n/config";
interface ExtendedTool {
  id: number;
  imageUrl?: string;
  prompt?: string;
  title?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  didUserLiked?: boolean;
  description?: string;
  videoUrl?: string;
  exitTickets?: ExitTicket[];
  createdAt?: string;
  authorId?: number;
  status?: BaseTeacherToolResponseDtoStatus;
  isEditable?: boolean;
  contentLanguage?: string;
}

const ExitTicketDetailComponent = ({ tool }: { tool: ExtendedTool }) => {
  return (
    <ExitTicketCard
      toolId={tool.id}
      status={tool.status}
      isEditable={tool.isEditable}
      authorName={tool.authorName || ""}
      authorId={tool.authorId}
      exitTickets={tool.exitTickets || []}
      imageUrl={tool.imageUrl!}
      videoUrl={tool.videoUrl}
      courseName={tool.courseName!}
      gradeLevel={tool.gradeLevel!}
      topic={tool.title || tool.prompt || ""}
      isImageLoading={false}
      createdAt={tool.createdAt ?? ""}
      contentLanguage={tool.contentLanguage || i18n.language}
    />
  );
};

const ExitTicketsView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserExitTicketGenerators}
      useDeleteTool={useDeleteExitTicketGenerator}
      getGetToolsQueryKey={getGetUserExitTicketGeneratorsQueryKey}
      useGetTopTools={useGetTopExitTicketGenerators}
      likeTool={likeExitTicketGenerator}
      unlikeTool={unlikeExitTicketGenerator}
      getGetTopToolsQueryKey={getGetTopExitTicketGeneratorsQueryKey}
      toolType="exitTickets"
      toolPath="exit-tickets"
      DetailComponent={ExitTicketDetailComponent}
      colors={{
        light: "from-green-400 to-teal-500",
        dark: "dark:from-green-300 dark:to-teal-400",
        iconBg: "bg-green-100 dark:bg-green-900/50",
        iconColor: "text-green-600 dark:text-green-300",
        hover: "hover:bg-green-50 dark:hover:bg-green-900/20",
      }}
      toolColor="green"
      gradientColor="purple"
    />
  );
};

export default ExitTicketsView;
